import { Nav } from "@/types/Navigation";

/**
 * Structural navigation defaults (URLs and assets only).
 * Translatable chrome copy lives in the Navigation next-intl namespace.
 */
export function createDefaultNavigation(): Nav {
  return {
    header: {
      logo: {
        url: "/trademark-logos/edx-logo-elm.svg",
        altText: "",
      },
      search: {
        placeholder: "",
      },
      navButton: {
        label: "",
      },
      cta: {
        signIn: {
          label: "",
          url: "",
        },
        register: {
          label: "",
          url: "",
        },
        business: {
          label: "",
          url: "https://business.edx.org",
        },
        dashboard: {
          label: "",
          url: "/dashboard/login",
        },
      },
    },
    sections: [],
  };
}
